import React from 'react';
import { IFeeEditLayout } from './IFeeEditLayout';
import classNames from 'classnames';
import type { FCWithChildren } from '../../../../../types/FCWithChildren';

export const FeeEditLayout: FCWithChildren<IFeeEditLayout> = ({ className, children }) => {
  return <div className={classNames('relative flex flex-col', className)}>{children}</div>;
};

export const FeeEditLayoutGroup: FCWithChildren<IFeeEditLayout> = ({ className, children }) => {
  return <div className={classNames(`flex flex-row flex-wrap gap-4`, className)}>{children}</div>;
};

export const FeeEditStickyBlock: FCWithChildren<IFeeEditLayout> = ({ layout, className, children }) => {
  return (
    <div
      className={classNames(
        'top-44 mt-4 flex flex-shrink-0 grow basis-[590px] flex-row flex-wrap self-start rounded-2xl p-4 shadow',
        layout === 'Single Column' ? '' : 'xl:sticky',
        className
      )}
    >
      {children}
    </div>
  );
};
